module.exports = __webpack_public_path__ + "img/16.549359f.png";